import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper
} from "@mui/material";
import html2canvas from "html2canvas";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { decryptAppId, decryptText } from "../../utils/encryption";

const ViewCertificate = () => {

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);

  const [searchParams] = useSearchParams();

  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");

  const appId = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgIdFromUrl = encryptedOrgId ? decryptText(encryptedOrgId) : null;

  const [certificateNo, setCertificateNo] = useState("");

  // ✅ FIXED API CALL
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!appId) return;

        const response = await axios.get(
          `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/GetMaincertificatedata`,
          {
            params: {
              appid: appId,
              labtypeid: 3
            }
          }
        );

        // Example
        setCertificateNo(response.data?.certificateNumber || "");

      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchData();
  }, [appId]);

  // ✅ Download Image
  const handleDownload = async (ref, fileName) => {
    if (!ref.current) return;

    const canvas = await html2canvas(ref.current);
    const image = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = image;
    link.download = fileName;
    link.click();
  };

  // ✅ Download PDF
  const handleDownloadUse = (filePath) => {
    window.open(filePath, "_blank");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",   // ✅ FIX (was center)
        backgroundColor: "#f5f7fa",
        py: 4 ,
        mt:4                      // ✅ spacing for scroll
      }}
    >
      <Paper sx={{ p: 4, width: 500, borderRadius: 3 }}>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Download NABL Symbol
        </Typography>

        {/* ✅ PDF */}
        <Box textAlign="center" mb={3}>
          <Button
            variant="contained"
            onClick={() => handleDownloadUse('/main/images/how to use symbol.pdf')}
          >
            Download How To Use Symbol
          </Button>
        </Box>

        {/* ✅ Size 1 */}
        <Box textAlign="center" mb={3}>
          <div ref={ref1} style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/2.5X3.5.png" style={{ width: "450px" }} />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(ref1, "2.5X3.5.png")}>
            Download 2.5 X 3.5
          </Button>
        </Box>

        {/* ✅ Size 2 */}
        <Box textAlign="center" mb={3}>
          <div ref={ref2} style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/2X2.25.png" style={{ width: "450px" }} />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(ref2, "2X2.25.png")}>
            Download 2 X 2.25
          </Button>
        </Box>

        {/* ✅ Size 3 */}
        <Box textAlign="center">
          <div ref={ref3} style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}} >
            <img src="/main/images/3.5X4.5.png" style={{ width: "450px" }} />
            <Typography fontWeight="bold" style={{paddingLeft:'1%'}}>
              {certificateNo || "Lab Name"}
            </Typography>
          </div>

          <Button onClick={() => handleDownload(ref3, "3.5X4.5.png")}>
            Download 3.5 X 4.5
          </Button>
        </Box>

      </Paper>
    </Box>
  );
};

export default ViewCertificate;